// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { jsonMember, jsonObject } from "typedjson";
import { MessageType, MessageTypeName } from "./messageTypes";

@jsonObject
export default class SendSteTxResponse extends PerunMessage {
  @jsonMember(String) transaction: string;

  constructor(transaction: string) {
    super();
    this.transaction = transaction;
  }

  messageType(): MessageType {
    return SendSteTxResponse;
  }

  messageTypeName(): MessageTypeName {
    return "SendSteTxResponse";
  }
}
